import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CgpPanelComponent } from './cgp-panel.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        CgpPanelComponent
    ],
    exports: [
        CgpPanelComponent
    ],
    providers: [
    ]

})
export class CgpPanelModule { }
